import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { BUILD_VERSION } from './buildVersion';

console.info('TSA build', BUILD_VERSION);

const CHUNK_RELOAD_KEY = 'tsa:chunk-reload-attempted';
const isChunkLoadFailure = (error: unknown) => {
  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : typeof error === 'string'
      ? error
      : '';

  return /ChunkLoadError|Loading chunk \d+ failed|Loading CSS chunk \d+ failed/i.test(message);
};
const recoverFromChunkLoadFailure = (error: unknown) => {
  if (!isChunkLoadFailure(error)) return;
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true') return;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  recoverFromChunkLoadFailure(event.error || event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  recoverFromChunkLoadFailure(event.reason);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('native-shell');
  SplashScreen.hide().catch(() => {
    // ignore errors if splash already hidden
  });
}

reportWebVitals();
